import { Card, Stack } from 'braid-design-system';

import { ListingUpgradeContactHeader } from './components/ListingUpgradeContactHeader';
import { ListingUpgradeContactItems } from './components/ListingUpgradeContactItems';

export const ListingUpgradeContact = () => (
  <Card tone="formAccent">
    <Stack space="large">
      <ListingUpgradeContactHeader />

      <ListingUpgradeContactItems />
    </Stack>
  </Card>
);
